import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const Flame = t0 => {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M5 0.5C5 4.9886 0.5 5.1278 0.5 8.39408C0.5 10.6621 2.51472 12.5 5 12.5C3.61696 12.5 2.49565 11.477 2.49565 10.215C2.49565 9.69464 2.70094 9.11216 2.99396 8.54576C3.20591 8.94789 3.46555 9.32759 3.76821 9.67808C3.76492 9.66044 3.76163 9.64208 3.75848 9.62504C3.52398 8.3114 3.93879 6.97016 4.87795 5.95172C4.95528 5.86772 5 5.82188 5 5.82188C5 8.3198 7.50422 8.39732 7.50422 10.215C7.50422 11.477 6.38304 12.5 5 12.5C7.48568 12.5 9.5 10.6617 9.5 8.39408C9.5 7.45892 9.13109 6.41228 8.60463 5.39408C8.22385 6.11688 7.75728 6.79936 7.21331 7.42928C7.21936 7.39728 7.22519 7.36552 7.2308 7.334C7.65231 4.97348 6.90687 2.5634 5.21937 0.734C5.08023 0.58316 5 0.5006 5 0.5006" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <IconWrapper {...props} variant="outline" viewBox="0 0 10 13" strokeWidth={1}>{t1}</IconWrapper>;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export { Flame };